import React from "react";

function Error() {
    return (
        <h3>Error Page</h3>
    )
}

export default Error;
